import { $httpPublic } from './http'

class PublicInvoicesService {
  getPublicDTE = async (uuid: string) => {
    const response = await $httpPublic.get(`/invoices/public/${uuid}`)
    return response.data
  }
}
export default new PublicInvoicesService()
